import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconDownloadSvg } from "./IconDownloadSvg.mjs";
const IconDownload = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconDownloadSvg, ...iconProps });
};
export {
  IconDownload
};
